import { VODCSSModules } from 'shared/utils/wix-connect';

import MenuButton from 'widget/views/desktop/compact/components/menu-button/menu-button';

import Animate from 'widget/views/desktop/compact/components/animate/animate';

import styles from './action-bar.styl';


@VODCSSModules(styles)
export default class ActionBar extends React.Component {

  static propTypes = {
    actions: React.PropTypes.element,

    height: React.PropTypes.number,

    areActionsVisible: React.PropTypes.bool,

    onMenuClick: React.PropTypes.func,
  };

  render() {
    const {
      actions,
      areActionsVisible,
      onMenuClick,
      height,
    } = this.props;

    return (
      <section style={{ height }}
               styleName="actions">
        <Animate activeClassName={styles['actions-animated']}
                 type="fade-in"
                 when={areActionsVisible}>
          {actions}
        </Animate>
        <Animate type="fade-in"
                 when={!areActionsVisible}>
          <MenuButton styleName="menu-button"
                      onClick={onMenuClick} />
        </Animate>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/action-bar/action-bar.js